export default {
    'name': 'pdf',
    'label': 'patent-view.dual.pdfSource',
    'version': '1.0',
    'getComponent': () => import('./Main.vue'),
    'tabIndex': 5,
    'left': true,
    'right': true,
    'singleView': true,
    'compareView': true,
    'exclusiveRoutePath': '/pdf',
    'aclReadPath': '',
    'aclCheckKey': 'pdf'
};
